<template>
  <div>
    <b-row class="mx-0 stat-row">
      <b-col v-for="stat in statTotals" class="stat-col" :key="stat.name">
        <template v-if="report.length === 0">
          <b-card bg-variant="lighter" class="text-center mb-4" style="position: relative; overflow: hidden;">
            <div class="placeholder big"></div>
            <div class="placeholder"></div>
            <div class="shimmer"></div>
          </b-card>
        </template>
        <template v-else>
          <b-card :bg-variant="stat.bgVariant || 'lighter'" :text-variant="stat.textVariant" :class="[stat.cardClass, stat.bgVariant ? 'no-border' : '']" class="text-center mb-4">
            <h3 :class="stat.class">
                {{ stat.prefix }}{{ stat.value || 0 }}{{ stat.suffix }}
                <span v-if="stat.subStat" class="text-muted small my-auto">({{ stat.subStat }})</span>
            </h3>
            <span :class="stat.cardClass ? '' : 'text-muted'">
                {{ stat.name }}
            </span>
          </b-card>
        </template>
      </b-col>
    </b-row>
  </div>
</template>

<style scoped>
.shimmer {
  background-image: linear-gradient(90deg, rgba(255,255,255,0) 0px, var(--light) 40px, rgba(255,255,255,0) 80px);
  background-size: 80px 100%;
  background-repeat: no-repeat;
  background-position: 0 0;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 80px;
  animation: shine-lines 2s infinite ease-in-out;
}
@keyframes shine-lines {
  0% {
    left: -80px;
  }
  100% {
    left: 100%;
  }
}
.placeholder {
  margin: 0 auto;
  height: calc(23px - 0.5rem);
  width: 40px;
  border-radius: 5px;
  background-color: var(--border);
}
.placeholder.big {
  height: 33px;
  width: 80px;
  margin-bottom: 1rem;
}
.stat-row {
  margin: 0 -15px !important;
  justify-content: center;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
}
.stat-col {
  white-space: nowrap;
  max-width: 300px;
}
.no-border {
  border: 0;
  padding-top: 2px;
  padding-bottom: 2px;
}
.gradient {
  background-image: linear-gradient(to bottom right, rgba(0,0,0,0.2), rgba(255,255,255,0.2));
}
</style>

<script>
  import { totalStats, getPrettyStatName, formatStat } from '@/reports/components/ReportUtils'
  import numeral from 'numeral'
  export default {
    props: {
      report: { required: true, type: Array },
      stats: { required: true, type: Array },
      subStats: { required: false, type: Array, default: () => [] },
      formatLastStat: { required: false, type: Boolean, default: false }
    },
    data () {
      return {

      }
    },
    computed: {
      statTotals () {
        let statFields = [].concat(this.stats)
        for (let ss of this.subStats) {
          statFields.push(ss.stat)
        }

        let totals = []
        try {
          totals = totalStats(this.report, statFields)
        } catch (e) {
          console.log("Error")
          console.log(e)
        }

        let formatted = []
        for (let statName of this.stats) {
          let obj = {}
          obj.name = getPrettyStatName(statName)
          obj.value = formatStat(statName, totals[statName])

          let ss = this.substat(statName)
          if (ss) {
            obj.subStat = formatStat(ss, totals[ss])
          }

          formatted.push(obj)
        }
        if (this.formatLastStat) {
          let last = formatted[formatted.length - 1]
          last.bgVariant = 'primary'
          last.textVariant = 'white'
          last.cardClass = 'bg-gradient'
        }

        console.log(formatted)

        return formatted
      }
    },
    methods: {
      arrayIntersection(array1, array2) {
        return array1.filter(value => -1 !== array2.indexOf(value))
      },
      substat (field) {
        for (let stat of this.subStats) {
          if (stat.parent === field) {
            return stat.stat
          }
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/StatsBar.vue